import React, { useState } from 'react';

export default function ContactSection() {
  const [copied, setCopied] = useState(false);
  const email = 'hello@example.com';  // replace before launch

  const copyEmail = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section
      id="contact"
      style={{
        padding: '3rem 1rem 2rem',
        background: 'rgba(30, 58, 138, 0.03)',
      }}
    >
      <div
        style={{
          maxWidth: '40rem',
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        <h2
          style={{
            fontFamily: '"Playfair Display", serif',
            fontSize: '2.2rem',
            fontWeight: 700,
            color: '#1a1a2e',
            marginBottom: '0.5rem',
            letterSpacing: '-0.01em',
          }}
        >
          ✉️ Get in touch
        </h2>
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '1rem',
            color: 'rgba(26, 26, 46, 0.82)',
            marginBottom: '2rem',
            lineHeight: 1.6,
          }}
        >
          Found a bug? Have a feature suggestion? Want a country added, or notice
          an Etsy fee that's out of date? Reach out — we read everything.
        </p>

        <div
          style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75rem',
            padding: '1.25rem 1.5rem',
            background: '#fefdf8',
            border: '2px solid #1a1a2e',
            borderRadius: '0.75rem',
            boxShadow: '4px 6px 0 rgba(26, 26, 46, 0.12)',
          }}
        >
          <a
            href={`mailto:${email}?subject=Etsy%20Fee%20Calculator%20Feedback`}
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '1.2rem',
              fontWeight: 700,
              color: '#1e3a8a',
              textDecoration: 'none',
              padding: '0.4rem 0.6rem',
            }}
          >
            {email}
          </a>
          <button
            onClick={copyEmail}
            style={{
              padding: '0.35rem 0.85rem',
              background: '#fefdf8',
              border: '1.5px solid #1a1a2e',
              borderRadius: '0.4rem',
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.86rem',
              fontWeight: 600,
              color: '#1a1a2e',
              cursor: 'pointer',
              boxShadow: '1px 2px 0 rgba(26, 26, 46, 0.15)',
            }}
          >
            {copied ? '✓ Copied!' : '📋 Copy email'}
          </button>
        </div>

        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.93rem',
            color: 'rgba(26, 26, 46, 0.74)',
            marginTop: '1.5rem',
            lineHeight: 1.6,
          }}
        >
          We typically respond within 1-2 business days.
        </p>
      </div>
    </section>
  );
}
